export const navsList = [
  {
    text: "首页",
    index: "1",
    location: { name: "home" },
    path: "/home",
    featureKey: "home",
    isShowList: [],
    children: [],
  },
  {
    text: "豆豆",
    index: "2",
    location: "",
    path: "",
    featureKey: "jollybeans",
    isShowList: [],
    children: [
      {
        text: "欢乐豆",
        index: "2-1",
        location: { name: "jollybeans" },
        path: "/jollybeans",
        featureKey: "jollybeans",
        icon: require('@/assets/images/home_new/hld_ico.png'),
        show: true,
        isShowList: [],
      },
      {
        text: "金豆",
        index: "2-2",
        location: { name: "goldbeans" },
        path: "/goldbeans",
        featureKey: "coin1",
        icon: require('@/assets/images/home_new/jd_ico.png'),
        show: true,
        isShowList: [],
      },
    ],
  },
  {
    text: "CSGO",
    index: "3",
    location: "",
    isShowList: [],
    children: [
      {
        text: "盲盒",
        index: "3-1",
        location: "",
        icon: require('@/assets/images/home_new/menu_icon/case.svg'),
        show: true,
        isShowList: [],
        children: [
          {
            text: "盲盒",
            index: "3-1-1",
            location: { name: "boxClassics" },
            show: true,
            path: "/box/classics",
            featureKey: "box",
          },
          {
            text: "自建",
            index: "3-1-2",
            location: { name: "boxDiy" },
            show: true,
            path: "/box/diy",
            featureKey: "box_diy",
          },
          {
            text: "合开",
            index: "3-1-3",
            location: { name: "multiplePeopleCaseList", params: { tabType: "all" } },
            show: true,
            path: "/multiplePeopleCaseList/all",
            featureKey: "multiple_people_case",
          }
        ],
      },
      {
        text: "盒战",
        index: "3-2",
        location: "",
        icon: require('@/assets/images/home_new/menu_icon/battle.svg'),
        show: true,
        isShowList: [],
        children: [
          {
            text: "盒战",
            index: "3-2-1",
            location: { name: "battle" },
            show: true,
            path: "/battle",
            featureKey: "battle",
          },
        ],
      },
      {
        text: "升级",
        index: "3-3",
        location: "",
        show: true,
        isShowList: [],
        icon: require('@/assets/images/home_new/menu_icon/upgrade.svg'),
        children: [
          {
            text: "经典",
            index: "3-3-1",
            location: { name: "upgradeList" },
            show: true,
            path: "/upgrade/list",
            featureKey: "upgrade",
          },
          {
            text: "欧皇",
            index: "3-3-2",
            location: { name: "upgrade2Detail" },
            show: true,
            path: "/upgrade/upgrade2",
            featureKey: "upgrade_euro",
          },
        ],
      },
      {
        text: "大逃杀",
        index: "3-4",
        location: { name: "battleRoyale" },
        show: true,
        path: "/battle-royale",
        featureKey: "battle_royale",
        children: [],
      },
    ],
  },
  {
    text: "活动",
    index: "4",
    location: { name: "eventIndex" },
    path: "/event/eventIndex",
    featureKey: "event",
    isShowList: [],
    children: [
      {
        text: "ROLL房",
        index: "4-1",
        location: { name: "rolls" },
        show: false,
        path: "/rolls",
        featureKey: "rolls",
      },
      {
        text: "优惠活动",
        index: "4-2",
        location: { name: "activity" },
        show: false,
        path: "/event/activity",
        featureKey: "activity",
      },
      {
        text: "战力奖励",
        index: "4-3",
        location: { name: "rebate" },
        show: false,
        path: "/event/rebate",
        featureKey: "rebate",
      },
      {
        text: "红包CDK",
        index: "4-4",
        location: { name: "redEnvelope" },
        show: false,
        path: "/event/redEnvelope",
        featureKey: "red_envelope",
      },
      {
        text: "VIP特权",
        index: "4-5",
        location: { name: "vipLevel" },
        show: false,
        path: "/event/vipLevel",
        featureKey: "vip_level",
      },
      // {
      //   text: "救援金",
      //   index: "4-6",
      //   location: { name: "subsidy" },
      //   show: false,
      //   path: "/event/subsidy",
      // },
    ],
  },
  {
    text: "商城",
    index: "5",
    location: { name: "shopVip" },
    path: "/shop/vip",
    featureKey: "shop",
    isShowList: [],
    children: [
      {
        text: "KJ商城",
        index: "5-1",
        location: { name: "shopVip" },
        show: false,
        path: "/shop/vip",
        featureKey: "shop_vip",
      },
      {
        text: "商城(一)",
        index: "5-2",
        location: { name: "shopGold" },
        show: false,
        path: "/shop/gold",
        featureKey: "shop_gold",
      },
      {
        text: "商城(二)",
        index: "5-3",
        location: { name: "shopUu" },
        show: false,
        path: "/shop/uu",
        featureKey: "shop_uu",
      },
      {
        text: "欢乐豆商城",
        index: "5-4",
        location: { name: "shopHappyCoin" },
        show: false,
        path: "/shop/happycoin",
        featureKey: "shop_happycoin",
      },
      {
        text: "金豆商城",
        index: "5-5",
        location: { name: "shopCoin1" },
        show: false,
        path: "/shop/coin1",
        featureKey: "shop_coin1",
      },
    ],
  },
];
